import logo from "../assets/coderpadLogo.png";

const Loader = ({ inline = false, isDarkMode = false }) => {
  // Inline variant - smaller, relative positioning
  if (inline) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="relative flex flex-col items-center gap-4">
          {/* Animated particles in background */}
          <div className="absolute inset-0 overflow-hidden">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="absolute w-0.5 h-0.5 bg-teal-400/30 dark:bg-teal-500/20 rounded-full"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animation: `particle-float ${3 + Math.random() * 4}s ease-in-out infinite`,
                  animationDelay: `${Math.random() * 2}s`
                }}
              />
            ))}
          </div>

          {/* Logo with animation */}
          <div className="relative">
            <img
              src={logo}
              alt="Loading"
              className="w-16 h-16 object-contain logo-flip"
            />
          </div>
        </div>

        <style>{`
          @keyframes particle-float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translateY(-50px) translateX(10px);
              opacity: 0;
            }
          }

          .logo-flip {
            animation: logo-flip 2s ease-in-out infinite;
          }

          @keyframes logo-flip {
            0%, 100% {
              transform: rotateY(0deg);
            }
            50% {
              transform: rotateY(180deg);
            }
          }
        `}</style>
      </div>
    );
  }

  // Full-screen variant (original)
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-teal-50 dark:from-[#0f1419] dark:via-[#1D1E23] dark:to-[#1a2a33]">
      {/* Animated particles in background */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-teal-400/30 dark:bg-teal-500/20 rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `particle-float ${3 + Math.random() * 4}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      {/* Main loader content */}
      <div className="relative z-10 flex flex-col items-center gap-10">
        {/* Logo with advanced animations */}
        <div className="relative">
          <div className="relative">
            <img
              src={logo}
              alt="Loading"
              className="w-36 h-36 md:w-44 md:h-44 object-contain logo-flip"
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes particle-float {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          100% {
            transform: translateY(-100px) translateX(20px);
            opacity: 0;
          }
        }

        .logo-flip {
          animation: logo-flip 2s ease-in-out infinite;
        }

        @keyframes logo-flip {
          0%, 100% {
            transform: rotateY(0deg);
          }
          50% {
            transform: rotateY(180deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;
